import { useEffect, useState, useRef } from 'react'
import { Col, Modal, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import Footer from './Footer'
import FormColumnTwo from './FormColumnTwoComponent'
import FormColumnOne from './FormColumnOneComponent'
import Header from './Header'
import SnapShotListTable from './SnapShotListTable'

import { alertService } from '../../../../../../_services/alert.service'
import { initialFormState } from '../../../../../planograms_v2/constants/filters'
import { submitSets } from '../../../../../UiComponents/SubmitSets'
import { submitCollection } from '../../../../../../_services/submit.service'

import '../../../../../planograms_v2/components/advanceFilter.scss'

const CopyArrangementModalComponent = ({
    dmode,
    dir,
    showModal,
    toggleFunc,
    department,
    defSaveObj,
    fieldCount,
    toggleLoadingModal,
    confirmModalShow,
    getSelectRowData,
    simulationObj,
    searchObj,
    getSimulationCallCopyArrangement,
    clusterId,
    fieldArrayId,
    clusters,
    editionId,
    validationModalShow,
}) => {
    const { t } = useTranslation()
    const isMountedRef = useRef(true)

    // Use clusters as the primary source for department information
    const departmentId = clusters?.[0]?.departmentId

    // Get department name from clusters
    const clusterWithDept = clusters?.find(c => c.department && c.department.name)
    let departmentName = clusterWithDept?.department?.name || `Department ${departmentId}`

    // Extract cluster and field array info
    const currentCluster = clusters?.find(c =>
        c.clusterId === clusterId || c.id === clusterId
    )

    const clusterName = currentCluster?.clusterName ||
                       currentCluster?.name ||
                       currentCluster?.cluster_name ||
                       `Cluster ${clusterId}`

    const currentFieldArray = currentCluster?.clusterFieldArrays?.find(
        fa => fa.fieldArrayId === fieldArrayId || fa.id === fieldArrayId
    )

    const fieldArrayName = currentFieldArray?.fieldArray?.name ||
                          currentFieldArray?.fieldArrayName ||
                          currentFieldArray?.name ||
                          currentFieldArray?.field_array_name ||
                          `Field Array ${fieldArrayId}`

    const [adavnceFilterFormVal, setAdavnceFilterFormVal] =
        useState(initialFormState)
    const [checkBoxSelectOptions, setCheckBoxSelectOptions] = useState('')
    const [filterState, setFilterState] = useState({})
    const [isDataReceived, setIsDataReceived] = useState(false)
    const [responseData, setResponseData] = useState([])

    const finalDepartmentName = departmentName

    const cleanupOnUnmount = () => {
        setCheckBoxSelectOptions('')
        setResponseData([])
    }

    useEffect(() => {
        isMountedRef.current = true
        if (showModal) {
            setIsDataReceived(false)
            setAdavnceFilterFormVal(initialFormState)
        }

        return () => {
            isMountedRef.current = false
            cleanupOnUnmount()
        }
    }, [showModal])

    const submitFilterFunc = (simulationFilterPayload) => {
        toggleLoadingModal(true)
        submitSets(
            submitCollection.newSimulation,
            simulationFilterPayload,
            false
        )
            .then((res) => {
                if (!isMountedRef.current) return
                if (!res) {
                    return alertService.error(t('DATA_LOADING_FAIL'))
                }
                setIsDataReceived(true)
                setResponseData(res)
            })
            .catch((e) => {})
            .finally(() => {
                if (isMountedRef.current) {
                    toggleLoadingModal(false)
                }
            })
    }

    const closeModal = () => {
        toggleFunc()
        setAdavnceFilterFormVal(initialFormState)
        setCheckBoxSelectOptions('')
        setResponseData([])
        getSelectRowData({})
    }

    const clearForm = () => {
        setAdavnceFilterFormVal(initialFormState)
        setCheckBoxSelectOptions('')
    }

    const backToForm = () => {
        setResponseData([])
        setIsDataReceived(false)
    }

    const getSelectRowDataFunc = (selectedRows) => {
        toggleLoadingModal(true)
        //const actFiledStructure = simulationObj.actualFieldStructures 

        const actFiledStructure = simulationObj.fieldList

        let layoutStructureList = []
        // actFiledStructure.forEach((field) => {
        //     layoutStructureList.push({
        //         fieldId: field.mpField.field_id,
        //         fieldName: field.mpField.field_name || field.mpField.fieldName || `Field ${field.mpField.field_id}`,
        //         width: field.mpField.field_width,
        //         height: field.mpField.field_height,
        //         depth: field.mpField.field_depth,
        //         uom: field.mpField.field_uom,
        //         order: field.order,
        //         shelves: field.mpField.field_shelves.map((shelf) => ({
        //             shelfRank: shelf.rank,
        //             height: shelf.height,
        //             width: shelf.width,
        //             gap: shelf.gap,
        //             uom: shelf.uom,
        //             isEyeLevel: false
        //         })),
        //     })
        // })
        // NEW WAY - 2026 FEB - DU EDIT CR
        actFiledStructure.forEach((field) => {
            layoutStructureList.push({
                fieldId: field.field_id,
                fieldName: field.field_name || field.fieldName || `Field ${field.field_id}`,
                width: field.width,
                height: field.height,
                depth: field.depth,
                uom: field.uom,
                order: field.order,
                shelves: field.shelf.map((shelf) => ({
                    shelfRank: shelf.rank,
                    height: shelf.height,
                    width: shelf.width,
                    gap: shelf.gap,
                    uom: shelf.uom,
                    isEyeLevel: false
                })),
            })
        })
        const payload = {
            simulationSnapshotId: selectedRows.snapshotId,
            layoutStructureList: layoutStructureList,
        }
        submitSets(submitCollection.compareFieldStructure, payload, false)
            .then((res) => {
                if (!isMountedRef.current) return
                //  DU EDIT CR - 2026 FEB
                if(!res.extra) return;
                if(res.extra?.isDifferentFieldStructure){
                    if(res.extra.canProceed){
                        const payload = { snapshotId: selectedRows.snapshotId }
                        getSimulationCallCopyArrangement(
                            payload,
                            selectedRows.fieldCount
                        )
                        closeModal()
                    }else{
                        validationModalShow(res.extra)
                        toggleLoadingModal(false)
                    }
                }else{
                    if(res?.extra?.isDifferentShelfStructure){
                        if(res.extra.canProceed){
                            confirmModalShow(res.extra)
                            toggleLoadingModal(false)
                        }else{
                            // Ask from the user if they want to proceed with shelf mismatch
                            confirmModalShow(res.extra)
                            toggleLoadingModal(false)
                        }
                    }else{
                        if(res.extra.canProceed){
                            const payload = { snapshotId: selectedRows.snapshotId }
                            getSimulationCallCopyArrangement(
                                payload,
                                selectedRows.fieldCount
                            )
                            closeModal()
                        }else{
                            validationModalShow(res.extra)
                            toggleLoadingModal(false)
                        }
                    }
                }

                // if (res.extra.isDifferentFieldStructure) {
                //     if (
                //         res.extra?.differences.differenceType ===
                //         'FIELD_DIMENSION_MISMATCH'
                //     ) {
                //         confirmModalShow(res.extra)
                //         toggleLoadingModal(false)
                //     } else if (
                //         res.extra?.differences.differenceType ===
                //         'SHELF_MISMATCH'
                //     ) {
                //         confirmModalShow(res.extra)
                //         toggleLoadingModal(false)
                //     } else if (
                //         res.extra?.differences.differenceType ===
                //         'SHELF_COUNT_MISMATCH'
                //     ) {
                //         confirmModalShow(res.extra)
                //         toggleLoadingModal(false)
                //     } else if (
                //         res.extra?.differences.differenceType ===
                //         'FIELD_COUNT_MISMATCH'
                //     ) {
                //         alertService.error(
                //             res.extra?.differences?.message,
                //             4000
                //         )
                //         toggleLoadingModal(false)
                //     } else {
                //         alertService.error(t('erroroccurred'))
                //         toggleLoadingModal(false)
                //     }
                // } else {
                //     if (res?.validation?.type === 'error') {
                //         alertService.error(t('erroroccurred'))
                //         return
                //     }
                //     const payload = { snapshotId: selectedRows.snapshotId }
                //     getSimulationCallCopyArrangement(
                //         payload,
                //         selectedRows.fieldCount
                //     )
                //     closeModal()
                // }
            })
            .catch((e) => {
                if (isMountedRef.current) {
                    toggleLoadingModal(false)
                    alertService.error(t('erroroccurred'))
                }
            })
            .finally(() => {
                // toggleLoadingModal(false)
            })
        getSelectRowData(selectedRows)
    }

    return (
        <>
            <Modal show={showModal} onHide={() => {}} size="xl">
                <Modal.Body
                    style={{
                        backgroundColor: dmode ? '#2f353e' : '',
                    }}
                    className={'modal-body-advanced-simulation'}
                    dir={dir}
                >
                    {isDataReceived ? (
                        <>
                            <Header
                                dmode={dmode}
                                depName={finalDepartmentName}
                                fieldCount={fieldCount}
                                header="SIMULATIONS"
                                simulationObj={simulationObj}
                                isTable={true}
                                t={t}
                                toggleFunc={closeModal}
                                clusterName={clusterName}
                                fieldArrayName={fieldArrayName}
                            />
                            <SnapShotListTable
                                t={t}
                                isRTL={dir}
                                dmode={dmode}
                                getSelectRowData={getSelectRowDataFunc}
                                responseData={responseData}
                                filterState={filterState}
                                submitFunc={submitFilterFunc}
                            />
                            <Footer
                                adavnceFilterFormVal={adavnceFilterFormVal}
                                checkBoxSelectOptions={checkBoxSelectOptions}
                                depId={departmentId}
                                dir={dir}
                                fieldCount={fieldCount}
                                simulationObj={simulationObj}
                                isTable={true}
                                t={t}
                                submitFunc={submitFilterFunc}
                                setFilterState={setFilterState}
                                callBackfunc={backToForm}
                                clusterId={clusterId}
                                fieldArrayId={fieldArrayId}
                                editionId={editionId}
                            />
                        </>
                    ) : (
                        <>
                            <Header
                                dmode={dmode}
                                depName={finalDepartmentName}
                                fieldCount={fieldCount}
                                header="COPY_ARR_FILTER"
                                simulationObj={simulationObj}
                                t={t}
                                toggleFunc={closeModal}
                                isTable={false}
                                clusterName={clusterName}
                                fieldArrayName={fieldArrayName}
                            />
                            <Row dir={dir}>
                                <FormColumnOne
                                    adavnceFilterFormVal={adavnceFilterFormVal}
                                    dmode={dmode}
                                    dir={dir}
                                    t={t}
                                    setAdavnceFilterFormVal={
                                        setAdavnceFilterFormVal
                                    }
                                    checkBoxSelectOptions={
                                        checkBoxSelectOptions
                                    }
                                    setCheckBoxSelectOptions={
                                        setCheckBoxSelectOptions
                                    }
                                />
                                <Col
                                    sm={0}
                                    md={0}
                                    lg={1}
                                    className="d-flex align-items-center justify-content-center"
                                >
                                    <div
                                        style={{
                                            borderLeft: '1.5px solid #828282',
                                            height: '100%',
                                        }}
                                    ></div>
                                </Col>
                                <FormColumnTwo
                                    adavnceFilterFormVal={adavnceFilterFormVal}
                                    depId={departmentId}
                                    defSaveObj={defSaveObj}
                                    dmode={dmode}
                                    dir={dir}
                                    t={t}
                                    setAdavnceFilterFormVal={
                                        setAdavnceFilterFormVal
                                    }
                                />
                                <Footer
                                    adavnceFilterFormVal={adavnceFilterFormVal}
                                    checkBoxSelectOptions={
                                        checkBoxSelectOptions
                                    }
                                    depId={departmentId}
                                    dir={dir}
                                    fieldCount={fieldCount}
                                    isTable={false}
                                    t={t}
                                    submitFunc={submitFilterFunc}
                                    simulationObj={simulationObj}
                                    setFilterState={setFilterState}
                                    callBackfunc={clearForm}
                                    clusterId={clusterId}
                                    fieldArrayId={fieldArrayId}
                                    editionId={editionId}
                                />
                            </Row>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CopyArrangementModalComponent